import axios from 'axios'
import api from '@/api'

const patientsInterview = {
  state: {
    data: []
  },
  getters: {
    getPatientsInterview: state => state.data,
    getPatientsInterviewData: state => state.data.data_fields,
    getPatientsSpecializationInterviewData: state => state.data.specializations,
  },
  mutations: {
    PATIENT_INTERVIEW_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsInterviewGet (context) {
      axios({
        method: 'POST',
        url: `${api}patients/interviews/template`,
      }).then(response => {
        context.commit('PATIENT_INTERVIEW_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    },
    patientsInterviewEditGet (context, value) {
      axios({
        method: 'POST',
        url: `${api}patients/interviews/item/` + value,
      }).then(response => {
        context.commit('PATIENT_INTERVIEW_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default patientsInterview
